
export default "/assets/pencil-micro.a215f9c2.svg"